export type ResponsivenessTags = Array<{
	min: number;
	max: number;
	rangeText: string;
	label: string;
	labelColor: string;
	textColor: string;
}>;

export function getScoreTag(tagsList: ResponsivenessTags, score: number | null) {
	if (score === null) return undefined;

	const tag = tagsList.find((t) => score >= t.min && score <= t.max);
	return tag
		? {
				label: tag.label,
				labelColor: /^#[a-f0-9]+$/i.test(tag.labelColor) ? tag.labelColor : '',
				textColor: /^#[a-f0-9]+$/i.test(tag.textColor) ? tag.textColor : '',
			}
		: undefined;
}
